<template>
  <div style="background: white" class="">
    <v-container class="table-container pa-0" fluid>
      <div class="tarjas-container">
        <div
          v-show="!(isMobile && !withSidebarGroup)"
          no-gutters
          class="ma-0 header-table-sticky"
        >
          <div v-if="withSidebarGroup" class="sidebar_h">
            <div class="sidebar-showed-h d-flex flex-row pa-1 pl-2">
              <v-checkbox
                v-if="selectable"
                v-model="selectedAll"
                class="icon-inline"
                dark
                @change="changeSelectedAll()"
              />
              <span
                v-show="groupBy.key"
                class="subtitle link"
                @click="orderBy('trabajador')"
              >
                <span>
                  {{ groupBy.name }}
                </span>
                <v-icon
                  v-if="orderedBy == 'trabajador'"
                  :class="{ rotate: isOrderAsc }"
                >arrow_drop_up</v-icon>
              </span>
              <v-spacer />
              <v-btn
                v-if="withSidebarExtended && !isMobile"
                fab
                depressed
                style="height: 28px; width: 28px;"
                class="ma-0 pa-0 white--text"
                :color="showSidebarExtended ? 'accent darken-3' : 'primary'"
                :class="{ rotate: showSidebarExtended }"
                @click="toggleSidebarExtended()"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div>
          </div>

          <template v-if="withSidebarExtended && !isMobile">
            <div v-if="showSidebarExtended" class="sidebar_extended_h">
              <v-row no-gutters>
                <v-col class="header-item">
                  valor dia
                </v-col>
                <v-col class="header-item">
                  $ hr extr
                </v-col>
              </v-row>
            </div>
          </template>

          <div class="items_content_h">
            <div
              v-if="withDate"
              class="header-item date_h full-mobile-width"
              :order="0"
            >
              fecha
            </div>

            <div class="icon_h d-print-none" />
            <div class="icon_h" />

            <div v-if="withValorDia" class="header-item valor_dia_h">
              <span>Valor dia</span>
            </div>

            <div v-if="withValorDia" class="header-item valor_hora_extra_h">
              <span>$hr extr</span>
            </div>

            <div
              v-show="groupBy.by != 'trabajador' || forcedShowTrabajador"
              class="header-item trabajador_h"
            >
              <span>Trabajador</span>
            </div>

            <div
              v-show="groupBy.by != 'sublabor'"
              class="header-item sub_labor_h"
            >
              <span>Labor</span>
            </div>

            <div class="header-item jornada_h">
              <span>Jornada</span>
            </div>

            <div
              v-show="groupBy.by != 'centrosCosto'"
              class="header-item centro_costo_h"
            >
              <span>C de costo</span>
            </div>

            <div class="header-item rendimiento_h">
              <span>Rend.</span>
            </div>

            <div class="header-item valor_unidad_h">
              <span>$/Un</span>
            </div>

            <div class="header-item hora_extra_h">
              <span>Hrs Ext</span>
            </div>

            <div class="header-item bono_h">
              <span>Bono</span>
            </div>

            <div class="header-item semana_corrida_h">
              <span>Sem Corrida</span>
            </div>

            <div class="header-item total_h">
              <b>Total</b>
            </div>

            <div class="icon_h d-print-none " :order="isMobile ? 2 : 'last'" />
            <v-spacer v-show="isMobile" class="d-print-none" :order="2" />
            <div class="icon_h d-print-none" :order="isMobile ? 2 : 'last'" />
          </div>
        </div>

        <!-- -->

        <v-row v-if="grouped.length == 0 && !loading">
          <v-col class="ma-5">
            <v-alert
              type="info"
              :value="true"
              border="left"
              icon="find_in_page"
              prominent
              text
            >
              <span v-if="dateSelected">
                Sin Tarjas en {{ dateSelectedFormated }}
              </span>
              <span v-else>
                Sin Tarjas
              </span>
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="loading">
          <v-col class="ma-5">
            <v-alert
              :value="true"
              border="left"
              icon="find_in_page"
              prominent
              text
            >
              Buscando tarjas
              <v-progress-linear
                color="accent"
                :indeterminate="true"
              />
            </v-alert>
          </v-col>
        </v-row>

        <div
          v-if="floatInput.visible"
          class="float-input"
          :style="{
            left: floatInput.left,
            top: floatInput.top,
            width: floatInput.width
          }"
        >
          <v-text-field
            v-show="floatInput.type == 'valor_dia'"
            :id="'valor_dia_' + floatInput.tarja.id"
            ref="valor_dia_input"
            v-model.number="floatInput.tarja.valor_dia"
            single-line
            hide-details
            :label="isMobile ? 'Valor dia' : ''"
            :prefix="isMobile ? 'valor dia' : ''"
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-text-field
            v-show="floatInput.type == 'valor_hora_extra'"
            :id="'valor_hora_extra_' + floatInput.tarja.id"
            :ref="'valor_hora_extra_input'"
            v-model.number="floatInput.tarja.valor_hora_extra"
            :label="isMobile ? '$ Hr ext' : ''"
            single-line
            hide-details
            :prefix="isMobile ? '$ Hr ext' : ''"
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-autocomplete
            v-show="floatInput.type == 'trabajador'"
            :id="'trabajador_' + floatInput.tarja.id"
            ref="trabajador_input"
            v-model="floatInput.tarja.trabajador"
            :items="trabajadores"
            single-line
            outlined
            class="small full-mobile-width"
            label="Trabajador"
            item-text="codname"
            return-object
            autocomplete="off"
            autofocus
            :error="floatInput.tarja.errorMsg.trabajador !== false"
            :error-messages="floatInput.tarja.errorMsg.trabajador || ''"
            hide-details
            v-on="floatInput.on"
          >
            <template v-slot:item="data">
              <template>
                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ data.item.codigo }} </b>
                    {{ data.item.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.rut"
                  />
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-show="floatInput.type == 'sublabor'"
            :id="'labor_' + floatInput.tarja.id"
            ref="sublabor_input"
            v-model="floatInput.tarja.sublabor"
            :items="labores"
            single-line
            outlined
            class="small full-mobile-width"
            label="Labor"
            item-text="codname"
            return-object
            autocomplete="off"
            autofocus
            :error="floatInput.tarja.errorMsg.sublabor !== false"
            :error-messages="floatInput.tarja.errorMsg.sublabor || ''"
            hide-details
            v-on="floatInput.on"
          >
            <template v-slot:item="data">
              <template>
                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ data.item.codigo }} </b>{{ data.item.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.labor.nombre"
                  />
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>

          <v-text-field
            v-show="floatInput.type == 'jornada'"
            :id="'porcentaje_' + floatInput.tarja.id"
            ref="jornada_input"
            v-model.number="floatInput.tarja.jornada"
            single-line
            hide-details
            class="small right full-mobile-width"
            :error="floatInput.tarja.errorMsg.jornada !== false"
            :error-messages="floatInput.tarja.errorMsg.jornada || ''"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-autocomplete
            v-show="floatInput.type == 'centrosCosto'"
            :id="'centrosCosto_' + floatInput.tarja.id"
            ref="centrosCosto_input"
            v-model="floatInput.tarja.centrosCosto"
            :items="centrosCosto"
            single-line
            outlined
            class="small full-mobile-width"
            label="Centro de costo"
            item-text="codname"
            return-object
            autocomplete="off"
            autofocus
            :error="floatInput.tarja.errorMsg.centrosCosto !== false"
            :error-messages="floatInput.tarja.errorMsg.centrosCosto || ''"
            hide-details
            v-on="floatInput.on"
          >
            <template v-slot:item="data">
              <template>
                <v-list-item-content>
                  <v-list-item-title>
                    <b>{{ data.item.codigo }} </b>{{ data.item.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="data.item.cuarteles">
                    {{
                      data.item.cuarteles.length +
                        " cuartel" +
                        (data.item.cuarteles.length > 1 ? "es" : "")
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>

          <v-text-field
            v-show="floatInput.type == 'rendimiento'"
            :id="'unidades_' + floatInput.tarja.id"
            ref="rendimiento_input"
            v-model.number="floatInput.tarja.rendimiento"
            :prefix="isMobile ? 'Rendimiento' : ''"
            single-line
            hide-details
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-text-field
            v-show="floatInput.type == 'valor_unidad'"
            :id="'valor_unidad_' + floatInput.tarja.id"
            ref="valor_unidad_input"
            v-model.number="floatInput.tarja.valor_unidad"
            single-line
            hide-details
            :prefix="isMobile ? '$ x Un.' : '$'"
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-text-field
            v-show="floatInput.type == 'horas_extras'"
            :id="'horasExtras_' + floatInput.tarja.id"
            ref="horas_extras_input"
            v-model.number="floatInput.tarja.horas_extras"
            single-line
            hide-details
            suffix="hrs"
            :prefix="isMobile ? 'hrs ext.' : ''"
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-text-field
            v-show="floatInput.type == 'bono'"
            :id="'bono_' + floatInput.tarja.id"
            ref="bono_input"
            v-model.number="floatInput.tarja.bono"
            single-line
            hide-details
            :prefix="isMobile ? 'Bono $' : '$'"
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />

          <v-text-field
            v-show="floatInput.type == 'semana_corrida'"
            :id="'semanaCorrida_' + floatInput.tarja.id"
            ref="semana_corrida_input"
            v-model.number="floatInput.tarja.semana_corrida"
            :prefix="isMobile ? 'Sem Corrida' : ''"
            single-line
            hide-details
            class="small right full-mobile-width"
            autocomplete="off"
            autofocus
            outlined
            v-on="floatInput.on"
          />
        </div>

        <v-row
          v-for="(group, indexGroup) in grouped"
          v-show="!loading"
          :key="'group-' + indexGroup"
          no-gutters
          class="ma-0 group"
          :class="{
            'secondary lighten-5': indexGroup % 2 == 0,
            white: indexGroup % 2 == 1,
            'new-group': group.isNew,
            'flex-nowrap': !isMobile,
            mobile: isMobile
          }"
        >
          <div v-if="withSidebarGroup" class="sidebar">
            <v-card flat tile class="sidebar-showed pl-2 pr-1">
              <v-row no-gutters>
                <v-col v-if="selectable" cols="auto" class="flex-shrink-1 pt-1">
                  <v-checkbox
                    v-model="group.selected"
                    class="icon-inline"
                    @change="changeSelect()"
                  />
                </v-col>
                <v-col class="subtitle-2 truncate title-group pt-1">
                  <v-tooltip v-if="group.by" top>
                    <template v-slot:activator="{ on }">
                      <span class="subheading" v-on="on">{{
                        group.by.nombre || group.by.name
                      }}</span>
                    </template>
                    <span>
                      <span>{{ group.by.nombre || group.by.name }}</span>
                    </span>
                  </v-tooltip>
                  <span v-else class="subheading error">ERROR: no group.by</span>
                </v-col>

                <v-col
                  v-show="!(isMobile && !group.showed)"
                  class="flex-grow-0"
                >
                  <v-btn
                    color="primary"
                    icon
                    small
                    height="34"
                    width="34"
                    @click="addTarjaGroup(group)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
                <v-col v-show="isMobile" class="flex-grow-0">
                  <v-btn
                    color="primary"
                    icon
                    small
                    height="34"
                    width="34"
                    :class="{ rotate: group.showed }"
                    @click="toggleShowGroup(group)"
                  >
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="isMobile && group.showed">
                <v-col cols="5" offset="1" class="py-0">
                  <v-text-field
                    v-show="groupBy.by == 'trabajador'"
                    v-if="group.contrato && dateSelected"
                    :ref="'vd'"
                    v-model="group.contrato.valor_dia"
                    single-line
                    hide-details
                    prefix="$"
                    suffix=" dia"
                    class="small right"
                    :loading="group.loading"
                    outlined
                    @input="debounceSaveContrato(group, null)"
                  />
                </v-col>

                <v-col cols="5" class="py-0">
                  <v-text-field
                    v-show="groupBy.by == 'trabajador'"
                    v-if="group.contrato && dateSelected"
                    :ref="'he'"
                    v-model="group.contrato.hora_extra"
                    single-line
                    hide-details
                    prefix="$"
                    suffix=" hrs ext"
                    class="small right"
                    :loading="group.loading"
                    outlined
                    @input="debounceSaveContrato(group)"
                  />
                </v-col>
              </v-row>
            </v-card>
          </div>

          <template v-if="withSidebarExtended && !isMobile">
            <div v-if="showSidebarExtended" class="sidebar-extended">
              <v-row
                no-gutters
                class="mx-0 flex-nowrap flex-column flex-sm-row flex-grow-1"
              >
                <v-col>
                  <v-text-field
                    v-show="groupBy.by == 'trabajador'"
                    v-if="group.contrato && dateSelected"
                    :ref="'vd'"
                    v-model="group.contrato.valor_dia"
                    single-line
                    hide-details
                    prefix="$"
                    suffix=" dia"
                    class="small right"
                    :loading="group.loading"
                    outlined
                    @input="debounceSaveContrato(group, null)"
                  />
                  <!--
              <span>{{group.contrato.valor_dia}}</span>
           -->
                </v-col>

                <v-col>
                  <v-text-field
                    v-show="groupBy.by == 'trabajador'"
                    v-if="group.contrato && dateSelected"
                    :ref="'he'"
                    v-model="group.contrato.hora_extra"
                    single-line
                    hide-details
                    prefix="$"
                    suffix=" hrs ext"
                    class="small right"
                    :loading="group.loading"
                    outlined
                    @input="debounceSaveContrato(group)"
                  />
                  <!--
              <span>{{group.contrato.hora_extra}}</span>
            -->
                </v-col>
              </v-row>
            </div>
          </template>

          <!--
    col-tarjas contiene las tarjas de un grupo completo
   -->
          <div
            v-if="!(isMobile && !group.showed) || !withSidebarGroup"
            class="col-tarjas"
            :cols="isMobile ? 12 : null"
          >
            <div class="tarja-container" :class="{ mobile: isMobile }">
              <v-card
                v-for="(tarja, indexTarja) in group.tarjas"
                :id="'tarja-' + tarja.id"
                :key="'tarja-' + indexTarja"
                :ref="'tarja-' + tarja.id"
                :color="indexGroup % 2 == 0 ? 'secondary lighten-5' : 'white'"
                class="tarja"
                :ripple="false"
                outlined
                :class="{
                  mobile: isMobile,
                  'ma-2': isMobile
                }"
                :tile="!isMobile"
                @click="!tarja.edit && edit(tarja)"
              >
                <v-card-text class="pa-0">
                  <v-container class="pa-0 text-tarja" fluid>
                    <v-row
                      class="mx-0 tarja-row"
                      no-gutters
                      :class="{
                        'flex-nowrap': !isMobile
                      }"
                    >
                      <v-col class="icon-content px-0 py-1 d-print-none" :order="1">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-show="tarja.validada_por"
                              color="green"
                              v-on="on"
                            >
                              check_circle
                            </v-icon>
                          </template>
                          <span v-if="tarja.validada_por">Validada por {{ tarja.validada_por.name }} <br>
                            {{ tarja.validada_por.updated_at_formated }}</span>
                        </v-tooltip>

                        <v-icon
                          v-show="tarja.validada_por == null"
                          color="grey lighten-1"
                        >
                          remove
                        </v-icon>
                      </v-col>

                      <v-col class="icon-content pa-0 " :order="1">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              color="green lighten-1"
                              height="34"
                              width="34"
                              dark
                              icon
                              v-on="on"
                            >
                              {{ tarja.dia == 0 ? "T" : "" }}
                              {{ tarja.dia == 1 ? "D" : "" }}
                              {{ tarja.dia == 2 ? "D+T" : "" }}
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in tiposTarjas"
                              :key="index"
                              @click="changeTratoTarja(tarja, item)"
                            >
                              <v-list-item-title>
                                <span class="green--text lighten-1">
                                  {{ item.cod }} -
                                </span>
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>

                      <v-col
                        v-if="withDate"
                        class="date-tarja pa-1 full-mobile-width"
                        :order="0"
                      >
                        <i> {{ tarja.fechaFormated }} </i>
                      </v-col>

                      <v-col
                        v-if="withValorDia"
                        _cols="1"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'valor_dia')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.valor_dia }"
                          class="span-input"
                          type-input="valor_dia"
                        >{{ tarja.valor_dia }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">Valor dia</span>
                      </v-col>

                      <v-col
                        v-if="withValorDia"
                        _cols="1"
                        class="fi-focusable"
                        :order="3"
                        @click="
                          showFloatInput($event, tarja, 'valor_hora_extra')
                        "
                      >
                        <span
                          :class="{
                            withError: tarja.errorMsg.valor_hora_extra
                          }"
                          class="span-input"
                          type-input="valor_hora_extra"
                        >{{ tarja.valor_hora_extra }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">$ Hr ext</span>
                        <v-divider v-if="isMobile" class="my-2" />
                      </v-col>

                      <v-col
                        v-show="
                          groupBy.by != 'trabajador' || forcedShowTrabajador
                        "
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'trabajador')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.trabajador }"
                          class="span-input"
                          type-input="trabajador"
                        >{{
                          tarja.trabajador ? tarja.trabajador.codname : "-"
                        }}</span>
                      </v-col>

                      <v-col
                        v-show="groupBy.by != 'sublabor'"
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'sublabor')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.sublabor }"
                          class="span-input"
                          type-input="sublabor"
                        >{{
                          tarja.sublabor ? tarja.sublabor.codname : "-"
                        }}</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'jornada')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.jornada }"
                          class="span-input"
                          type-input="jornada"
                        >{{ tarja.jornada }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">Jornada</span>
                      </v-col>

                      <v-col
                        v-show="groupBy.by != 'centrosCosto'"
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'centrosCosto')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.centrosCosto }"
                          class="span-input"
                          type-input="centrosCosto"
                        >{{
                          tarja.centrosCosto
                            ? tarja.centrosCosto.codname
                            : "-"
                        }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">C costo</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'rendimiento')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.rendimiento }"
                          class="span-input"
                          type-input="rendimiento"
                        >{{ tarja.rendimiento }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">Rendimiento</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'valor_unidad')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.valor_unidad }"
                          class="span-input"
                          type-input="valor_unidad"
                        >$ {{ tarja.valor_unidad }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">$ / Uni</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'horas_extras')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.horas_extras }"
                          class="span-input"
                          type-input="horas_extras"
                        >{{ tarja.horas_extras }} hrs</span>
                        <span class="prefix d-print-none hidden-md-and-up">Hrs Ext.</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'bono')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.bono }"
                          class="span-input"
                          type-input="bono"
                        >
                          $ {{ tarja.bono }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">Bono</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="fi-focusable"
                        :order="3"
                        @click="showFloatInput($event, tarja, 'semana_corrida')"
                      >
                        <span
                          :class="{ withError: tarja.errorMsg.semana_corrida }"
                          class="span-input"
                          type-input="semana_corrida"
                        >
                          $ {{ tarja.semana_corrida }}</span>
                        <span class="prefix d-print-none hidden-md-and-up">Sem Corr</span>
                      </v-col>

                      <v-col
                        _cols="3"
                        class="total-content pa-1 full-mobile-width"
                        :order="3"
                      >
                        <b> $ {{ formatPrice(tarja.valor_total) }} </b>
                      </v-col>

                      <v-col
                        class="icon-content d-print-none"
                        :order="isMobile ? 2 : 'last'"
                      >
                        <v-btn
                          :class="{
                            'secondary--text text--darken-2':
                              !tarja.isNew && !tarja.error,
                            'red--text text--darken-1': tarja.error,
                            'green--text text--darken-1':
                              tarja.isNew && !tarja.error
                          }"
                          icon
                          x-small
                          :loading="tarja.loading"
                          @click="saveTarja(tarja, false)"
                        >
                          <v-icon>save</v-icon>
                        </v-btn>
                      </v-col>
                      <v-spacer v-show="isMobile" class="order-1" />
                      <v-col
                        class="icon-content d-print-none"
                        :order="isMobile ? 2 : 'last'"
                      >
                        <v-menu
                          offset-y
                          min-width="100"
                          transition="slide-x-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              slot="activator"
                              color="primary"
                              text
                              icon
                              small
                              v-on="on"
                            >
                              <v-badge
                                color="accent"
                                overlap
                                :value="
                                  tarja.trabajador.contratistas.length > 0 &&
                                    tarja.contratista_id > 0
                                "
                                left
                                dot
                              >
                                <v-icon>more_vert</v-icon>
                              </v-badge>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-menu
                              v-show="tarja.trabajador.contratistas.length > 0"
                              open-on-hover
                              :close-on-content-click="false"
                              left
                              offset-x
                              open-delay="100"
                            >
                              <template v-slot:activator="{ on }">
                                <v-list-item
                                  :close-on-content-click="false"
                                  v-on="on"
                                >
                                  <v-list-item-icon>
                                    <v-icon dense>
                                      chevron_left
                                    </v-icon>
                                  </v-list-item-icon>

                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Contratistas
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>

                              <v-list dense>
                                <v-list-item
                                  v-for="contratista in tarja.trabajador
                                    .contratistas"
                                  :key="contratista.id"
                                  @click="selectContratista(tarja, contratista)"
                                >
                                  <v-list-item-action>
                                    <v-icon
                                      v-if="
                                        contratista.id == tarja.contratista_id
                                      "
                                    >
                                      check_box
                                    </v-icon>
                                    <v-icon v-else>
                                      check_box_outline_blank
                                    </v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title>
                                    {{
                                      contratista.nombre
                                    }}
                                  </v-list-item-title>
                                </v-list-item>
                                <v-divider />
                                <v-list-item
                                  @click="selectContratista(tarja, null)"
                                >
                                  <v-list-item-action>
                                    <v-icon v-if="null == tarja.contratista_id">
                                      check_box
                                    </v-icon>
                                    <v-icon v-else>
                                      check_box_outline_blank
                                    </v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title>Empresa</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>

                            <v-list-item @click="duplicateTarja(tarja, group)">
                              <v-list-item-icon>
                                <v-icon dense>
                                  filter_none
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title>
                                  Duplicar
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>

                            <v-divider />

                            <v-list-item
                              color="red"
                              @click="deleteTarja(tarja, group)"
                            >
                              <v-list-item-icon>
                                <v-icon dense class="red--text">
                                  delete
                                </v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title class="red--text">
                                  Eliminar Tarja
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- .tarja -->
            </div>
            <!-- .tarja-container -->
          </div>
          <!-- .col-tarjas-->
        </v-row>
      </div>

      <select-personas
        v-model="showedSelectPersonas"
        :fullscreen="isMobile"
        :personas="trabajadores"
        :disabled="disabledTrabajadores"
        :no-button="true"
        title="Titulo de prueba"
        @selected="selectTrabajadoresDuplicate"
      />
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import tarjaModel from "@/models/tarjaModel";
import contratoModel from "@/models/contratoModel";
import selectPersonas from "@/components/selectPersonas";

export default {
  name: "ListTarjas",
  components: {
    selectPersonas
  },
  props: {
    dateSelected: {default:moment().format("YYYY-MM-DD"), type:String},
    value: {default : () => [] , type: Array},
    tarjas: {default : () => [] , type: Array},
    contratos: {default : () => [] , type: Array},
    tiposContrato: {default : () => [] , type: Array},
    centrosCosto: {default : () => [] , type: Array},
    labores: {default : () => [] , type: Array},
    withSidebarExtended: { default: true , type: Boolean},
    withDuplicate: { default: true , type: Boolean},
    addEnabled: { default: true , type: Boolean},
    selectable: { default: true , type: Boolean},
    withSidebarGroup: { default: true , type: Boolean},
    withDate: { default: false , type: Boolean},
    withValorDia: { default: false , type: Boolean},
    forcedShowTrabajador: { default: false , type: Boolean},
    orderListBy: { default: "" , type: String},
    trabajadores: {default : () => [] , type: Array},
    disabledTrabajadores: {default : () => [] , type: Array},
    tarjaDefault: {default : () => {} , type: Object},
    loading: {default : false    , type: Boolean},
      /*{name : "Por Trabajador", key : "trabajador.id",    by : "trabajador"}*/
    groupBy: { default: () => ({ name : "Sin orden", key : null, by : null }) , type: Object},
  },
  data() {
    return {
      orderedBy: "trabajador",
      isOrderAsc: true,
      grouped: [],
      debounceSaveFn: null,
      showSidebarExtended: false,
      loadingGeneral: false,
      selectedAll: false,
      tarjaDuplicate: null,
      showedSelectPersonas: false,
      errorMsgModel: {
        //codigo duplicado
        jornada: false,
        valorTotal: false,
        trabajador: false,
        sublabor: false,
        centrosCosto: false
      },
      tiposTarjas: [
        {
          label: "Dia",
          cod: "D",
          value: 1
        },
        {
          label: "Trato",
          cod: "T",
          value: 0
        },
        {
          label: "Dia + Trato",
          cod: "D+T",
          value: 2
        }
      ],
      floatInput: {
        left: 0,
        top: 0,
        visible: false,
        type: null,
        on: null,
        tarja: {
          id: null
        }
      }
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    dateSelectedFormated() {
      return moment(this.dateSelected).format("DD [de] MMMM");
    },
    howManyGroupsSelected() {
      return _.sumBy(this.grouped, group => {
        return group.selected ? 1 : 0;
      });
    },
    lastGroup() {
      return Object.keys(this.grouped).length - 1;
    }
  },

  watch: {
    groupBy() {
      this.init();
    },
    tarjas() {
      //this.init();
      //this.clearSelection();
      //this.$emit('input', this.tarjasSelected());
    }
  },

  created() {
    if (this.orderListBy) {
      this.orderBy(this.orderListBy);
    } else {
      this.init();
    }
  },

  methods: {
    showFloatInput(event, tarja, type) {
      if (!event.target.classList.contains("span-input")) return;

      var target = event.target;
      var self = this;
      var childPosLeft = target.offsetParent.offsetLeft;
      var parentPosLeft = target.offsetParent.offsetParent.offsetLeft;
      var childPosTop = target.offsetParent.offsetTop;
      var parentPosTop = target.offsetParent.offsetParent.offsetTop;

      if (!this.isMobile) {
        window.removeEventListener("resize", this.hideInput);
        window.addEventListener("resize", this.hideInput);
      }

      this.floatInput.visible = true;
      this.floatInput.tarja = tarja;
      this.floatInput.type = type;
      this.floatInput.top = childPosTop + parentPosTop + "px";
      this.floatInput.left = childPosLeft + parentPosLeft + "px";
      this.floatInput.width = target.offsetParent.offsetWidth + "px";

      //cerrar menu del input seleccionado
      var vuetifyInput = self.$refs[type + "_input"];
      if (vuetifyInput) {
        self.$nextTick(() => {
          if (vuetifyInput.isMenuActive) {
            vuetifyInput.isMenuActive = false;
          }
          setTimeout(() => {
            vuetifyInput.focus();
            if (vuetifyInput.select) {
              vuetifyInput.select();
            }
            if (vuetifyInput.$refs.input.select) {
              vuetifyInput.$refs.input.select();
            }
          }, 100);
        });
      }

      this.floatInput.on = {
        input() {
          self.debounceSave(tarja);
        },
        keyup: e => {
          var type = self.floatInput.type;
          var vuetifyInput = self.$refs[type + "_input"];
          var nextTarget, prevTarget;

          //para cerrar menu actual, antes de mover input

          /*
            var vuetifyInput = self.$refs[type+'_input'];
            if(vuetifyInput){
              if(vuetifyInput.isMenuActive){
                vuetifyInput.isMenuActive = false;
              }
            }
            */

          switch (e.code) {
            case "Escape":
              if (vuetifyInput) {
                if (vuetifyInput.isMenuActive) {
                  vuetifyInput.isMenuActive = false;
                } else {
                  this.floatInput.visible = false;
                  e.stopPropagation();
                }
              }
              break;
            case "ArrowUp":
              if (vuetifyInput) {
                if (!vuetifyInput.isMenuActive) {
                  var prevTarja = this.getPrevTarja(tarja);
                  if (prevTarja) {
                    var prevTarjaElement = document.getElementById(
                      "tarja-" + prevTarja.id
                    );
                    if (prevTarjaElement) {
                      prevTarget = prevTarjaElement.querySelector(
                        '.span-input[type-input="' + type + '"]'
                      );
                      self.showFloatInput(
                        { target: prevTarget },
                        prevTarja,
                        type
                      );
                    }
                  }
                }
              }

              break;
            case "ArrowDown":
              if (vuetifyInput) {
                if (!vuetifyInput.isMenuActive) {
                  var nextTarja = this.getNextTarja(tarja);
                  if (nextTarja) {
                    var nextTarjaElement = document.getElementById(
                      "tarja-" + nextTarja.id
                    );
                    if (nextTarjaElement) {
                      nextTarget = nextTarjaElement.querySelector(
                        '.span-input[type-input="' + type + '"]'
                      );
                      self.showFloatInput(
                        { target: nextTarget },
                        nextTarja,
                        type
                      );
                    }
                  }
                }
              }

              break;
            case "ArrowLeft":
              console.log("left");
              if (vuetifyInput) {
                if (vuetifyInput.isMenuActive) {
                  vuetifyInput.isMenuActive = false;
                }
              }
              var prev = target.parentElement.previousSibling;
              if (prev && prev.classList.contains("fi-focusable")) {
                prevTarget = prev.firstElementChild;
                type = prevTarget.getAttribute("type-input");
                self.showFloatInput({ target: prevTarget }, tarja, type);
              }
              break;
            case "ArrowRight":
              console.log("right");
              vuetifyInput = self.$refs[type + "_input"];
              if (vuetifyInput) {
                if (vuetifyInput.isMenuActive) {
                  vuetifyInput.isMenuActive = false;
                }
              }
              var next = target.parentElement.nextSibling;
              if (next && next.classList.contains("fi-focusable")) {
                nextTarget = next.firstElementChild;
                type = nextTarget.getAttribute("type-input");
                self.showFloatInput({ target: nextTarget }, tarja, type);
              }
              break;
            default:
          }
        }
      };
    },
    getPrevTarja(tarja) {
      var prev = null;
      var auxPrev = null;
      _.forEach(this.grouped, gr => {
        _.forEach(gr.tarjas, t => {
          if (t == tarja) {
            prev = auxPrev;
          } else {
            auxPrev = t;
          }
        });
      });
      return prev;
    },

    getNextTarja(tarja) {
      var next = null;
      var found = null;
      _.forEach(this.grouped, gr => {
        _.forEach(gr.tarjas, t => {
          if (next == null) {
            if (found) {
              next = t;
            }
            if (t == tarja) {
              found = t;
            }
          }
        });
      });
      return next;
    },

    toggleSidebarExtended() {
      this.showSidebarExtended = !this.showSidebarExtended;
      this.hideInput();
    },

    hideInput() {
      this.floatInput.visible = false;
    },

    init() {
      console.log("init");
      if (this.tarjas !== undefined && this.contratos != undefined) {
        var self = this;
        var tarjas = this.tarjas; //_.cloneDeep(this.tarjas);

        _.forEach(tarjas, tarja => {
          tarja.fechaFormated = moment(tarja.fecha).format("DD MMM");
          tarja.dirtyTratoTarja = false;
          this.checkTarja(tarja);
        });

        this.grouped = this.groupByFn(
          tarjas,
          this.groupBy.key,
          this.groupBy.by,
          this.contratos
        );

        //asumiendo la existencia de by.nombre
        //ordena los grupos, si el orderedBy y el groupBy son lo mismo
        if (this.orderedBy == this.groupBy.by) {
          this.grouped = _.orderBy(
            this.grouped,
            ["by.nombre"],
            [this.isOrderAsc ? "asc" : "desc"]
          );
        }

        this.grouped = _.values(this.grouped);
        this.disabledPersonasDialog = [];
        /*
          this.grouped.forEach(group => {
            this.disabledPersonasDialog.push(group.by);
          });
          */

        //comentado, para revisar en la version Native
        //this.$nextTick(()=>{//cuando grouped ya esté en el DOM
        //self.refreshEventsInput();
        //});
      }

      this.debounceSaveFn = _.debounce(function(params) {
        //guardar tarja
        //this.refreshSumTarja(params.tarja);
        params.tarja.group.refreshSum();
        self.saveTarja(params.tarja, false);
      }, 1000);

      this.debounceSaveContratoFn = _.debounce(function({ group, tarjaRef }) {
        //guardar Contrato
        console.log("debounceSaveContratoFn");
        self.saveContrato(group, tarjaRef);
      }, 1000);
    },

    //revisar, posiblemente deprecada
    refreshSumTarja(tarja) {
      //recalculo de total
      if (tarja.valor_unidad && tarja.rendimiento && !tarja.dia) {
        //a trato
        tarja.valor_total = tarja.valor_unidad * tarja.rendimiento;
        //tarja.dia = tarja.dirtyTratoTarja ? tarja.dia : false; //"T";
      } else if (
        tarja.jornada &&
        tarja.trabajador &&
        tarja.trabajador.contrato &&
        tarja.dia
      ) {
        //al dia
        tarja.valor_total =
          parseFloat(tarja.valor_dia) * parseFloat(tarja.jornada);
        //tarja.valor_total = parseFloat(tarja.trabajador.contrato.valor_dia) * parseFloat(tarja.jornada);
        //tarja.dia = tarja.dirtyTratoTarja ? tarja.dia : true; //"T";
      } else {
        tarja.valor_total = 0;
        //tarja.dia = tarja.dirtyTratoTarja ? tarja.dia : true; //"T";
      }
      if (tarja.bono) {
        tarja.valor_total += tarja.bono;
      }
      if (
        tarja.horas_extras &&
        tarja.trabajador &&
        tarja.trabajador.contrato &&
        tarja.trabajador.contrato.hora_extra
      ) {
        tarja.valor_total +=
          tarja.horas_extras * parseFloat(tarja.trabajador.contrato.hora_extra);
      }
    },

    //https://stackoverflow.com/questions/43208012/how-do-i-format-currencies-in-a-vue-component
    formatPrice(value) {
      if (isNaN(value)) return "-";
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    orderBy(varName) {
      console.log("orderBy " + varName);
      var orderedBy = varName || "trabajador";
      if (orderedBy == this.orderedBy) {
        this.isOrderAsc = !this.isOrderAsc;
      } else {
        this.isOrderAsc = true;
      }
      this.orderedBy = orderedBy;
      this.init();
    },

    //https://gist.github.com/JamieMason/0566f8412af9fe6a1d470aa1e089a752
    //this.groupBy(this.tarjas, "trabajador.id", "trabajador");
    groupByFn(array, key, by, contratos) {
      key = key || null;

      switch (this.orderedBy) {
        case "contratista":
          //array = _.orderBy(array, ["centrosCosto.nombre"], [this.isOrderAsc?"asc":"desc"]);
          break;
        case "centro_costo":
          array = _.orderBy(
            array,
            ["centrosCosto.nombre"],
            [this.isOrderAsc ? "asc" : "desc"]
          );
          break;
        case "labor":
          array = _.orderBy(
            array,
            ["sublabor.nombre"],
            [this.isOrderAsc ? "asc" : "desc"]
          );
          break;
        case "fecha":
          array = _.orderBy(
            array,
            ["fecha"],
            [this.isOrderAsc ? "asc" : "desc"]
          );
          break;
        case "trabajador":
          array = _.orderBy(
            array,
            ["trabajador.nombre"],
            [this.isOrderAsc ? "asc" : "desc"]
          );
          break;
        default:
      }

      //variable que hace la relacion entre valueId y index, esto es para obtener
      // la variable r ordenada, no por valueId, sino por aparicion
      //(asignando al acumulador un orden por aparicion )
      var keyIndexCollection = {};

      var r = array.reduce((acumulador, obj, index) => {
        const valueId = _.get(obj, key) || "sin grupo";
        const byValue = _.get(obj, by) || "sin grupo";
        var value = index;
        var isNew = false;

        if (keyIndexCollection[valueId] !== undefined) {
          value = keyIndexCollection[valueId];
        } else {
          keyIndexCollection[valueId] = index;
          isNew = true;
        }

        //byValue.isNew                       = byValue.isNew == undefined ? false: byValue.isNew;
        acumulador[value] = acumulador[value] || {}; //iguala o crea uno nuevo
        acumulador[value].tarjas = (acumulador[value].tarjas || []).concat(obj);

        //si es un grupo nuevo, lo inicializa
        if (isNew) {
          acumulador[value].by = byValue;
          acumulador[value].selected = false;
          acumulador[value].showed = false;
          acumulador[value].loading = false;
          acumulador[value].valor_total = 0;
          acumulador[value].jornada_total = 0;

          acumulador[value].refreshSum = function() {
            this.jornada_total = _.sumBy(this.tarjas, tarja => {
              return tarja.jornada;
            });
            this.valor_total = _.sumBy(this.tarjas, tarja => {
              //self.refreshSumTarja(tarja);
              return tarja.valor_total;
            });
          }.bind(acumulador[value]);
        }

        obj.group = acumulador[value];

        if (by == "trabajador" && byValue) {
          //TODO mejorable con config
          acumulador[value].contrato = _.find(contratos, {
            trabajador_id: byValue.id
          });
        }
        return acumulador;
      }, {});

      //refresca las sumas de cada grupo
      _.forEach(r, group => {
        group.refreshSum();
      });

      return r;
    },

    toggleShowGroup(group) {
      console.log("toggleShowGroup");
      this.hideInput();
      group.showed = !group.showed;
    },

    addTarjaGroup(group) {
      if (!this.tarjaDefault) {
        console.error("tarja default undefined");
        return;
      }
      var newTarja = _.clone(this.tarjaDefault); //verificar estructura de tarjaDefault
      newTarja.isNew = true;
      newTarja.errorMsg = _.clone(this.errorMsgModel);

      newTarja.cleanErrorMsg = function(tarja) {
        tarja.errorMsg = _.clone(this.errorMsgModel);
      }.bind(this);

      if (this.groupBy.by == "trabajador") {
        newTarja.trabajador = group.by;
        if (
          newTarja.trabajador.contratistas &&
          newTarja.trabajador.contratistas.length > 0
        ) {
          newTarja.contratista_id = _.first(
            newTarja.trabajador.contratistas
          ).id;
        }
      }

      newTarja.group = group;
      group.tarjas.push(newTarja);
      this.tarjas.push(newTarja);

      //this.$emit('change', this.tarjas);
      /*
        newTarja.loading = true;
        setTimeout(function () {
          newTarja.loading = false;
        }.bind(this),
        2000)
        */
    },

    edit(tarja) {
      if (tarja == null) return null;
      _.forEach(this.tarjas, t => {
        t.isEdit = false;
      });
      tarja.isEdit = true;
    },

    checkTarja(tarja) {
      var isValid = true;

      /*
        if(tarja.valor_total == null){
          console.warn("valor_total no selected");
          tarja.errorMsg.valorTotal = "Valor total invalido";
          isValid = false;
        } 
        */

      if (tarja.jornada > 1 && !tarja.trabajador.super_hombre) {
        console.warn("jornada muy alta");
        tarja.errorMsg.jornada = "jornada muy alta";
      }

      if (tarja.trabajador == null) {
        console.warn("trabajador_id no selected");
        tarja.errorMsg.trabajador = "Trabajador invalido";
        isValid = false;
      }
      if (tarja.sublabor == null) {
        console.warn("sub_labor_id no selected");
        tarja.errorMsg.sublabor = "Labor invalida";
        isValid = false;
      }
      if (tarja.centrosCosto == null) {
        console.warn("centro_costo_id no selected");
        tarja.errorMsg.centrosCosto = "Centro de costo invalido";
        isValid = false;
      }
      return isValid;
    },

    debounceSave(tarja) {
      console.log("debounceSave");
      this.debounceSaveFn({ tarja: tarja });
    },

    debounceSaveContrato(group, tarjaRef) {
      console.log("debounceSaveContrato");
      this.debounceSaveContratoFn({ group, tarjaRef });
    },

    // TODO: revisar, existen grupos sin contrato
    //tarja es de referencia, para fecha y contrato
    saveContrato(group, tarjaRef) {
      var date = tarjaRef ? tarjaRef.fecha : this.dateSelected;

      if (!this.dateSelected) {
        console.error("dateSelected undefined");
      }

      group.loading = true;
      var contrato = group.contrato
        ? group.contrato
        : tarjaRef.trabajador.contrato;
      var data = {
        ...contrato,
        fecha: date
      };

      if (tarjaRef && tarjaRef.valor_dia) {
        data.valor_dia = tarjaRef.valor_dia;
      }

      if (tarjaRef && tarjaRef.valor_hora_extra) {
        data.valor_hora_extra = tarjaRef.valor_hora_extra;
      }

      return contratoModel.save(contrato.id, data).then(() => {
        _.forEach(group.tarjas, async tarja => {
          if (moment(tarja.fecha).isSame(moment(date), "day")) {
            tarja.trabajador.contrato.valor_dia = data.valor_dia;
            tarja.trabajador.contrato.hora_extra = data.hora_extra;
            //tarjasUpdate.push(tarja);
            try {
              await this.saveTarja(tarja, false);
            } catch (e) {
              console.error(tarja.id);
            } finally {
              console.log(tarja.id);
            }
          }
        });

        group.loading = false;
      });
    },

    saveAllTarjas() {
      _.forEach(this.tarjas, async tarja => {
        try {
          await this.saveTarja(tarja, false);
        } catch (e) {
          console.error(tarja.id);
        } finally {
          console.log(tarja.id);
        }
      });
    },

    saveTarja(tarja, withEvents = true) {
      //this.$nextTick(function(){
      var self = this;
      //var withEvents = withEvents === undefined ? true : withEvents;
      tarja.cleanErrorMsg(tarja);
      //var tarjaClone = _.cloneDeep(tarja); //<<-- por modificaciones al hacer checkTarja
      if (this.checkTarja(tarja)) {
        tarja.loading = true;
        self.loadingGeneral = true;
        tarja.error = false;

        if (withEvents) {
          this.$forceUpdate();
        }

        var d = {
          fecha: tarja.fecha
            ? moment(tarja.fecha).format("YYYY-MM-DD")
            : this.dateSelected,
          jornada: tarja.jornada || 0,
          rendimiento: tarja.rendimiento || 0,
          //valor_dia       : tarja.valor_dia, //<< contrato
          valor_unidad: tarja.valor_unidad || 0,
          horas_extras: tarja.horas_extras || 0,
          bono: tarja.bono || 0,
          semana_corrida: tarja.semana_corrida || 0,
          dia: tarja.dia,
          //valor_total      : tarja.valor_total || 0,
          valor_total: 0,
          valor_dia: tarja.trabajador.contrato.valor_dia,
          valor_hora_extra: tarja.trabajador.contrato.hora_extra,
          trabajador_id: tarja.trabajador.id,
          sub_labor_id: tarja.sublabor.id,
          centro_costo_id: tarja.centrosCosto.id
        };

        if (tarja.id) {
          d.id = tarja.id;
        }

        /*
        if(d.asistencia_id == null){
        delete d.asistencia_id;
      }
      */

        /*
      if(tarja.valor_hora_extra ){
      d.valor_hora_extra = tarja.valor_hora_extra;
    }
    if(tarja.valor_dia){
    d.valor_dia = tarja.valor_dia;
  }
  */

        if (tarja.rendimiento) {
          d.rendimiento = tarja.rendimiento;
        }

        if (tarja.contratista_id) {
          d.contratista_id = tarja.contratista_id;
        }
        if (d.id === undefined) {
          d = { tarjas: [d] }; // creacion de tarjas dentro de array
        }

        return tarjaModel.saveOrAdd(d).then(
          res => {
            var data = res.data;
            if (res.data.tarjas) {
              data = res.data.tarjas[0];
            }
            if (data.id) {
              tarja.id = data.id;
            }
            if (data.valor_total) {
              tarja.valor_total = data.valor_total;
            }
            tarja.isNew = false;
            tarja.trabajador_id = tarja.trabajador.id;
            tarja.sub_labor_id = tarja.sublabor.id;
            tarja.centro_costo_id = tarja.centrosCosto.id;
            tarja.loading = false;
            self.loadingGeneral = false;
            if (withEvents) {
              self.$forceUpdate();
            }
            self.$emit("change", this.tarjas);
          },
          resError => {
            tarja.loading = false;
            self.loadingGeneral = false;
            tarja.error = true;
            console.error(resError);
          }
        );
      } else {
        console.log("saveTarja: no valid tarja");
        this.loadingGeneral = false;
        tarja.error = true;
      }
      self.$forceUpdate();
      //})
    },

    deleteTarja(tarja, group) {
      if (confirm("¿Seguro desea eliminar esta tarja?")) {
        if (tarja.isNew) {
          var index = this.tarjas.indexOf(tarja);
          var indexGroup = group.tarjas.indexOf(tarja);
          this.tarjas.splice(index, 1);
          group.tarjas.splice(indexGroup, 1);
        } else {
          tarjaModel.delete(tarja.id).then(
            () => {
              var index = this.tarjas.indexOf(tarja);
              var indexGroup = group.tarjas.indexOf(tarja);
              this.tarjas.splice(index, 1);
              group.tarjas.splice(indexGroup, 1);
              if (group.tarjas.length == 0) {
                var indexGrouped = this.grouped.indexOf(group);
                this.grouped.splice(indexGrouped, 1);
              }
            },
            resError => {
              console.error(resError);
            }
          );
        }
      }
    },

    changeTratoTarja(tarja, item) {
      tarja.dia = item.value;
      tarja.dirtyTratoTarja = true;
      this.saveTarja(tarja, false);
    },

    addGroup() {
      this.grouped.unshift({
        isNew: true,
        tarjas: [],
        valor_total: 0,
        jornada_total: 0,
        selected: false,
        by: null
      });
    },

    //seleccion de grupos
    changeSelect() {
      if (this.selectedAll) {
        this.selectedAll = false;
      }
      this.$emit("input", this.tarjasSelected());
    },

    changeSelectedAll() {
      _.map(this.grouped, group => {
        group.selected = this.selectedAll;
      });
      this.$emit("input", this.tarjasSelected());
    },

    clearSelection() {
      this.selectedAll = false;
      this.changeSelectedAll();
    },

    tarjasSelected() {
      console.log("tarjasSelected");
      var ts = [];
      _.forEach(this.grouped, group => {
        _.forEach(group.tarjas, tarja => {
          if (group.selected) {
            ts.push(tarja);
          }
        });
      });
      return ts;
    },

    duplicateTarja(tarja) {
      this.tarjaDuplicate = tarja;
      this.showedSelectPersonas = true;
    },

    selectTrabajadoresDuplicate(trabajadores) {
      var promises = [];
      if (this.tarjaDuplicate && trabajadores) {
        this.tarjaDuplicate.loading = true;
        _.forEach(trabajadores, trabajador => {
          var tarja = _.clone(this.tarjaDuplicate);
          delete tarja.id;
          tarja.trabajador_id = trabajador.id;
          tarja.trabajador = trabajador;

          if (
            tarja.contratista_id &&
            !_.find(trabajador.contratistas, { id: tarja.contratista_id })
          ) {
            tarja.contratista_id = null;
          }

          promises.push(this.saveTarja(tarja, false));
        });
      }
      Promise.all(promises).then( () => {
        this.$emit("change", this.tarjas);
      });
    },

    selectContratista(tarja, contratista) {
      tarja.contratista_id = contratista ? contratista.id : null;
      this.saveTarja(tarja, false);
    }
  }
};
</script>
<style lang="scss">
$header_height: 33px;
$total_width: 100px;
$autocomplete_width: 180px;
$item_min_width: 100px;
$mini_width: 270px;
$header_height: 30px;

.v-input {
  .v-text-field__prefix,
  .v-text-field__suffix {
    color: rgba(0, 0, 0, 0.5);
  }

  &.x-small {
    font-size: 13px;
    border-radius: 0px;
    margin-bottom: -1px;
    &.v-input--is-focused {
      .v-input__slot {
        background: rgba(255, 255, 255, 0.7) !important;
      }
      fieldset {
        border-width: 1px;
      }
    }
    .v-input__slot {
      min-height: unset;
      background: rgba(255, 255, 255, 0.3);
      height: 27px;
    }
    label {
      top: 8px;
      font-size: 13px;
    }
    .v-input__append-inner {
      margin-top: 7px;
    }
  }

  &.small {
    font-size: 14px;
    border-radius: 0px;
    margin-bottom: -1px;
    &.v-input--is-focused {
      .v-input__slot {
        background: rgba(255, 255, 255, 0.7) !important;
      }
      fieldset {
        border-width: 1px;
      }
    }
    .v-input__slot {
      min-height: unset;
      background: rgba(255, 255, 255, 0.3);
      height: 35px;
    }
    label {
      top: 8px;
      font-size: 14px;
    }
    .v-input__append-inner {
      margin-top: 7px;
    }
  }

  &.center {
    input {
      text-align: center;
      padding-right: 4px;
    }
  }
  &.right {
    input {
      text-align: right;
      padding-right: 4px;
    }
  }

  &.v-input--checkbox.icon-inline {
    display: inline-block;
    margin: 0px;
    padding: 0px;
    .v-input__slot {
      margin: 0px;
    }
    .v-messages {
      display: none;
    }
  }
}
//------

.header-table-sticky {
  color: white;
  background: rgba(30, 136, 229, 1); //blue 600
  height: $header_height;
  margin: 0px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 3;
  text-align: left;
  min-width: max-content;
  div {
    vertical-align: top;
  }

  .items_content_h {
    display: inline-block;
    z-index: 1;
  }

  .sidebar_h {
    width: 250px;
    background: rgba(21, 101, 192, 1); //blue 800
    height: inherit;
    display: inline-block;
    position: sticky;
    left: 0;
    z-index: 3;
  }
  .sidebar_extended_h {
    width: 250px;
    position: sticky;
    left: 250px;
    background: rgba(25, 118, 210, 1); //blue 700;
    height: inherit;
    display: inline-block;
    z-index: 2;
  }
  .icon_h {
    width: 40px;
    height: inherit;
    display: inline-block;
  }
  .header-item {
    display: inline-block;
    padding: 0px 6px;
    text-align: center;
    height: 30px;
    line-height: 30px;

    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }

    &.date_h {
      min-width: 5em;
    }

    &.valor_dia_h {
      min-width: 5em;
    }
    &.valor_hora_extra_h {
      min-width: 5em;
    }
    &.trabajador_h {
      min-width: 10em;
    }
    &.sub_labor_h {
      min-width: 10em;
    }
    &.jornada_h {
      min-width: 5em;
    }
    &.centro_costo_h {
      min-width: 7em;
    }
    &.rendimiento_h {
      min-width: 5em;
    }
    &.valor_unidad_h {
      min-width: 5em;
    }
    &.hora_extra_h {
      min-width: 5em;
    }
    &.bono_h {
      min-width: 6.25em;
    }
    &.semana_corrida_h {
      min-width: 6.25em;
    }
    &.total_h {
      min-width: 6.25em;
    }
  }

  .icon-h {
    min-width: 40px;
    max-width: 40px;
    width: 40px;
  }
}

.table-container {
  position: relative;
  font-size: 14px;

  .total-content,
  .total-content-h {
    width: $total_width;
    min-width: $total_width;
    max-width: $total_width;
    display: inline-block;
  }

  .sidebar {
    border-right: 1px dotted rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 1);
    position: sticky;
    left: 0;
    z-index: 2;
    min-width: 250px;
    width: 250px;
    & > .v-card {
      background: transparent;
    }
    &:hover .fab-add-tarja {
      opacity: 1;
    }
    .fab-add-tarja {
      position: absolute;
      right: -20px;
      top: 20px;
      opacity: 0;
      transition: 0.3s all ease;
      z-index: 1;
      &.mobile {
        opacity: 1 !important;
      }
    }
  }

  .sidebar-showed {
    position: sticky;
    top: 30px;
  }
  .sidebar-showed,
  .sidebar-showed-h {
    min-width: 150px;
  }

  .sidebar-extended-h {
    height: $header_height;
  }

  .sidebar-extended-h {
    width: 250px;
    min-width: 250px;
    border-right: 1px dotted rgba(0, 0, 0, 0.2);
    .item-h {
      flex-grow: 1;
      flex-basis: 0;
      //min-width: $item_min_width;
    }
  }

  .sidebar-extended {
    width: 250px;
    left: 250px;
    position: sticky;
    min-width: 250px;
    border-right: 1px dotted rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 1);
    z-index: 2;
    .item-h {
      flex-grow: 1;
      flex-basis: 0;
      //min-width: $item_min_width;
    }
  }

  .card-container-h {
    overflow-x: hidden;
    flex-basis: 0;
    .item-h {
      flex-grow: 1;
      flex-basis: 0;
    }
    &::-webkit-scrollbar {
      height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      //background: rgba(0, 0, 0, 0.2);
      background-color: rgba(239, 108, 0, 0.5);
      border-radius: 4px;
      transition: all 1s ease;
      &:active,
      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }

  .card-container {
    overflow-x: scroll !important;
    flex-basis: 0;
  }

  .group.mobile {
    .col-tarjas {
      width: 100%;
      overflow-x: scroll;
      .tarja {
        //elevation 4
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
          0px 4px 5px 0px rgba(0, 0, 0, 0.14),
          0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
        span.span-input {
          border: 1px solid #42a5f5; // blue 400
        }
      }
    }
  }

  .tarjas-container {
    overflow: scroll;
    position: relative;
    height: calc(100vh - 130px); //patch

    .col-tarjas {
      //overflow:hidden;
      .tarja-container {
        width: max-content;

        .tarja {
          max-width: unset;
          min-width: min-content;
          break-after: avoid;
          break-before: avoid;
          &:not(.mobile) {
            border-width: 0px 0px 1px 0px;
            .date-tarja {
              max-width: 5em;
              min-width: 5em;
              text-align: center;
            }
            .span-input {
              &[type-input="valor_dia"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="valor_hora_extra"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="trabajador"] {
                min-width: 10em;
                max-width: 10em;
              }
              &[type-input="sublabor"] {
                min-width: 10em;
                max-width: 10em;
              }
              &[type-input="jornada"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="centrosCosto"] {
                min-width: 7em;
                max-width: 7em;
              }
              &[type-input="rendimiento"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="valor_unidad"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="horas_extras"] {
                min-width: 5em;
                max-width: 5em;
              }
              &[type-input="bono"] {
                min-width: 6.25em;
                max-width: 6.25em;
              }
              &[type-input="semana_corrida"] {
                min-width: 6.25em;
                max-width: 6.25em;
              }
            }
          }
          &.mobile {
            padding: 8px 8px;
            margin-right: 10px;
            flex: 0 0 $mini_width !important;
            max-width: $mini_width;
            border-color: #03a9f4 !important;
            display: inline-block !important;
            .container {
              .row {
                & > .col:not(.icon-content) {
                  flex: 0 0 100%;
                  max-width: 100%;
                  min-width: 100%;
                }
              }
            }

            .v-input {
              flex: unset !important;
            }
          } // .mobile

          .icon-content {
            min-width: 40px;
            max-width: 40px;
            width: 40px;
            text-align: center;
          }
          .item {
            max-width: unset;
            min-width: max-content;
            width: max-content;
          }
        }
      }
    }
  }
  //}
} // .table-container


//-----------------

span.span-input {
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: block;
  color: rgba(0, 0, 0, 0.8);
  height: 35px;
  line-height: 30px;
  padding: 0px 15px 0px 10px;
  margin-bottom: -1px;
  text-align: right;
  overflow: hidden;
  &.withError {
    border-color: red;
  }
}

.float-input {
  position: absolute;
  background: white;
  width: 20px;
  min-height: 20px;
  z-index: 3;
  box-shadow: 0px 0px 2px 4px rgba(14, 72, 161, 0.4);
  transition: 0.05s all ease;
}

.fi-focusable {
  position: relative;
  .prefix {
    position: absolute;
    left: 0;
    top: 0;
    color: rgba(117, 117, 117, 1);
    line-height: 34px;
    padding-left: 6px;
  }
}


@media print{
  .table-container,
  .table-container .v-card__text{
    font-size: 11px !important;
  }  
  .table-container{
    .tarjas-container{
      height: auto !important;
      overflow:visible;
    }
  }
}
</style>
